import { render, staticRenderFns } from "./edit_user_model.vue?vue&type=template&id=4748701d&scoped=true&"
import script from "./edit_user_model.vue?vue&type=script&lang=js&"
export * from "./edit_user_model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4748701d",
  null
  
)

export default component.exports